import React, { useEffect } from 'react';
import { getMe } from '../../Store/Slices/authSlice';
import { useGeneralHooks } from '../../Hooks/hooks'
import useHomePageHooks from './homePage-hooks';
import useLanguagesHooks from '../../Components/Languages/setLanguage-hooks';
import HomeHeader from '../../Components/Headers/HomeHeader/homeHeader';
import { IGetMe } from '../../Interfaces/responseTypes';
import { ButtonTypes } from '../../Interfaces/componentTypes';
import Button from '../../Components/Button/button';
import Loading from '../../Components/Loading/loading';
import styles from './home.module.scss';

const HomePage: React.FC = () => {
  const { isUser, currentUser, dispatch, onLogout, getMeError } = useGeneralHooks();
  const { pageContent, onSetPageContent, PAGE_CONTENTS } = useHomePageHooks();
  const {t} = useLanguagesHooks();

  useEffect(() => {
    dispatch(getMe())
  }, [dispatch]);

  useEffect(() => {
  if ("Notification" in window && Notification.permission === "default") {
    Notification.requestPermission();
  }
}, []);

  return (
    <div className={styles.page}>
      {isUser(currentUser) ?
        <div>
          <HomeHeader
            user={(currentUser as IGetMe).user}
            active={pageContent}
            onNavHandle={onSetPageContent}
          />
          <div className={styles.pageContent}>
            {PAGE_CONTENTS[`${pageContent}`]}
          </div>
        </div>
        :
        <div className={styles.loadingContainer}>
          <Loading />
          {
            getMeError &&
            <div className={styles.loginButtonBox}>
              <p>
                {t('Errors.Expired')}
              </p>
            <Button
              buttonType={ButtonTypes.Primery}
              onClick={() => onLogout({ isExpired: true })}
              title={t('Login.Title')}
            />
            </div>
          }
        </div>
      }
    </div>
  )
}

export default HomePage
